import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMastercard = function SvgMastercard(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 14"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#EB001B",
        d: "M7.636 6.96A6.3 6.3 0 0 1 9.96 2.066 6.27 6.27 0 0 0 6.142.737a6.09 6.09 0 0 0-6.14 6.224A6.149 6.149 0 0 0 9.96 11.94a6.64 6.64 0 0 1-2.324-4.98"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F79E1B",
        d: "M13.777.737a6.27 6.27 0 0 0-3.818 1.328 6.323 6.323 0 0 1 0 9.792 6.27 6.27 0 0 0 3.818 1.327 6.223 6.223 0 1 0 0-12.447",
        opacity: 0.5
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5A00",
        d: "M12.283 7.044c0-.938-.18-1.864-.583-2.71-.402-.848-1.016-1.677-1.742-2.269-1.411 1.162-2.325 2.987-2.325 4.979s.833 3.734 2.326 4.895a6.3 6.3 0 0 0 2.324-4.895",
        opacity: 0.75
    })));
};

export { SvgMastercard as ReactComponent };
//# sourceMappingURL=Mastercard.svg.es.js.map
